import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { BusinessAccountRequestService } from '../services';
import { BUSINESS_ACCOUNT_REQUEST_LIST_KEY } from '../constants';

const useAcceptBusinessAccountRequest = (id: string, onSuccess?: () => void) => {
  const { t } = useTranslation(['businessAccountRequest', 'errors']);
  const queryClient = useQueryClient();

  return useMutation(() => BusinessAccountRequestService.accept(id), {
    onSuccess: () => {
      toast.success(t('successAccepted'));
      queryClient.invalidateQueries({ queryKey: [BUSINESS_ACCOUNT_REQUEST_LIST_KEY] });
      onSuccess?.();
    },
    onError: () => {
      toast.error(t('generalErrorMessage', { ns: 'errors' }));
    },
  });
};

export default useAcceptBusinessAccountRequest;
